var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opening"},[_vm._v("正在打开管理员打款页面…")])}
var staticRenderFns = []

export { render, staticRenderFns }